<div *ngIf="showHeader" class="mc-build-progress-bar-header">
  <b>Build Progress</b>

  <span class="mc-fill-remaining-flex-space"></span>

  <span [ngClass]="textColorClassForBuildState">
    {{ statusDisplayText }}
    <ng-container *ngIf="build.IsStopped">
      after {{ build.RanFor | mcDuration }}
    </ng-container>
  </span>
</div>

<mat-progress-bar mode="determinate" [color]="colorForBuildState" [value]="build.Progress"></mat-progress-bar>

<div *ngIf="showFooter" class="mc-build-progress-bar-footer">
  <span class="mc-text-muted">
    {{ errorCount | number: '1.0-0' }} {{ errorCount === 1 ? 'Error' : 'Errors' }},
    {{ warningCount | number: '1.0-0' }} {{ warningCount === 1 ? 'Warning' : 'Warnings' }}
  </span>
  <span class="mc-fill-remaining-flex-space"></span>

  <span class="mc-text-muted">{{ build.Progress | number: '1.0-0' }}%</span>
</div>
